import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import CheckCircle from "@material-ui/icons/CheckCircle";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Button, FormControl, InputLabel, MenuItem, MenuList, Select, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import GCT_COURSE from "./CourseAssets/GCT.json";
import "./globalCommunityTutorials.scss";
import CourseCard from "./CourseCard";
import translate from "../../../i18n/translate";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { getLearnerProgressBloom } from "../../../redux/actions/globalCommunityTutoraials";

const GlobalCommunityTutorials = () => {
  const dispatch = useDispatch();
  const [gctUnits, setGctUnits] = useState<any[]>([]);
  const [gctTutorials, setGctTutorials] = useState<any[]>([]);
  const [gctCourse, setGctCourse] = useState<any[]>([]);
  const [selectedUnit, setSelectedUnit] = useState<any>("");
  const [availableTutorials, setAvailableTutorials] = useState<any[]>([]);
  const [selectedTutorial, setSelectedTutorial] = useState<any>("");
  const [completedTutorials, setCompletedTutorials] = useState<any[]>([]);
  const { globalCommunityTutorials: { data}, common: { lgId } } = useSelector((state: any) => state);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const { Tutorials, Units } = GCT_COURSE;
    if (Units) {
      setGctUnits(Units);
    }
    if (Tutorials) {
      setGctTutorials(Tutorials);
      const mixedTutorialIds = Tutorials.slice().map((tutorial: any) => tutorial.NodeId).join(",");
      dispatch(getLearnerProgressBloom(lgId, mixedTutorialIds));
    }
  }, []);

  useEffect(() => {
    if (gctTutorials.length > 0 && gctUnits.length > 0) {
      gctUnits.forEach((units: any) => {
        gctCourse[units.Name] = gctTutorials.slice().filter((tutorial: any) => tutorial.UnitId === units.Id);
      });
      setSelectedUnit(gctUnits[0].Name);
      setGctCourse(gctCourse);
    }
  }, [gctUnits, gctTutorials]);

  useEffect(() => {
    if (selectedUnit !== "") {
      const unitId = gctUnits.slice().filter((unit: any) => unit.Name === selectedUnit);
      if (unitId[0]) {
        const tutorials = gctTutorials.slice().filter((tutorial: any) => tutorial.UnitId === unitId[0].Id);
        if (tutorials) {
          setAvailableTutorials(tutorials);
          setSelectedTutorial(tutorials[0].NodeId);
        }
      }
    }
  }, [selectedUnit]);

  useEffect(() => {
    if (Object.keys(data).length > 0 && data.status === 200 && data.data) {
      const doneNodeIds: any[] = [];
      data.data.forEach((eachNode: any) => {
        if (eachNode.lessonCompleted === "1") {
          doneNodeIds.push(eachNode.nodeId);
        }
      })
      setCompletedTutorials(doneNodeIds);
    }
  }, [data])

  const iconStyles = {
    selectIcon: {
      color: "green",
    },
  };

  const CustomExpandMore = withStyles(iconStyles)(({ className, classes, ...rest }: any) => {
    return (
      <>
        <FormatListBulletedIcon {...rest} className={`${className} first-icon`} />
        <KeyboardArrowDownIcon {...rest} className={className} />
      </>
    );
  });

  const checkModuleCompleted = (id: any) => {
    return completedTutorials.includes(id);
  };

  const toGlobalCommunityTutorials = (NodeId: any, Topic: any) => {
    const changeTopic = Topic.replaceAll(" ", "");
    window.open(`${process.env.REACT_APP_PROGRESS_URL}/GCVideos/${changeTopic}/${NodeId}?isSimplified=true`, "_blank");
  };

  return (
    <div className="gct-container">
      <div className="gct-container-wrapper">
        <div className="gct-header">
          <h4 className="gct-header-title">Global community tutorials</h4>
          <div className="gct-description-box">
            <p className="gct-description">
              Improve your English language skills with this growing collection of community-developed lessons.
            </p>
            <div className="select-filter-box">
              <p className="select-filter-title">Select a category and tutorial:</p>
              <div className="form-control-box">
                <FormControl variant="outlined" className="select-form-control">
                  <InputLabel id="CategoryLabel" className="select-form-label">
                    Select a category
                  </InputLabel>
                  <Select
                    labelId="CategoryLabel"
                    id="category"
                    value={selectedUnit}
                    onChange={(e) => setSelectedUnit(e.target.value)}
                    className="select-box"
                    label="Select a category"
                  >
                    {gctUnits.map((units: any) => (
                      <MenuItem key={units.Id} value={units.Name} className="select-option">
                        {units.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" className="select-form-control">
                  <InputLabel id="TutorialLabel" className="select-form-label">
                    Select a tutorial
                  </InputLabel>
                  <Select
                    labelId="TutorialLabel"
                    id="tutorial"
                    value={selectedTutorial}
                    onChange={(e) => setSelectedTutorial(e.target.value)}
                    className="select-box"
                    label="Select a category"
                  >
                    {availableTutorials.map((tutorial: any) => (
                      <MenuItem key={tutorial.NodeId} value={tutorial.NodeId} className="select-option">
                        {tutorial.Title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <Button
                variant="contained"
                className="ok-button"
                onClick={() => toGlobalCommunityTutorials(selectedTutorial, selectedUnit)}
              >
                {translate("twt_class_policy_ok")}
              </Button>
            </div>
          </div>
        </div>
        <div className="gct-core-container">
          {Object.keys(gctCourse).map((course: any,index:number) => (
            <div key={index} className="course-container-wrapper">
              <div className="each-course-container">
                <h5>
                  {course} ({gctCourse[course].length})
                </h5>
                <Select IconComponent={CustomExpandMore} className="tutorials-list-dropdown" id={course}>
                  <div className="list-menu-dropdown-container">
                    {gctCourse[course].map((eachTutorial: any,index:number) => (
                      <MenuList
                        key={index}
                        className="list-menu-dropdown"
                        onClick={() => toGlobalCommunityTutorials(eachTutorial.NodeId, course)}
                      >
                        <CheckCircle
                          className={`status-icon ${checkModuleCompleted(eachTutorial.NodeId) ? "addBg" : ""}`}
                        />
                        <p className="tutorial-title">{eachTutorial.Title}</p>
                      </MenuList>
                    ))}
                  </div>
                </Select>
              </div>
              <div className="course-cards-container">
                <Slider {...settings}>
                  {gctCourse[course].map((eachTutorial: any) => (
                    <CourseCard
                    key={eachTutorial.NodeId}
                      cardImage={eachTutorial.ImageSource}
                      nodeId={eachTutorial.NodeId}
                      cardTitle={eachTutorial.Title}
                      duration={eachTutorial.Duration}
                      level={eachTutorial.Level}
                      showStatus={checkModuleCompleted(eachTutorial.NodeId)}
                      toGlobalCommunityTutorials={toGlobalCommunityTutorials}
                      course={course}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GlobalCommunityTutorials;
